var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 2H16.5C14.1139 2.00261 11.8262 2.95165 10.1389 4.63892C8.45165 6.32618 7.50261 8.61385 7.5 11V24.5C7.50261 26.8861 8.45165 29.1738 10.1389 30.8611C11.8262 32.5483 14.1139 33.4974 16.5 33.5H21C23.3861 33.4974 25.6738 32.5483 27.3611 30.8611C29.0483 29.1738 29.9974 26.8861 30 24.5V11C29.9974 8.61385 29.0483 6.32618 27.3611 4.63892C25.6738 2.95165 23.3861 2.00261 21 2ZM27.75 24.5C27.7481 26.2896 27.0364 28.0054 25.7709 29.2709C24.5054 30.5364 22.7896 31.2481 21 31.25H16.5C14.7104 31.2481 12.9946 30.5364 11.7291 29.2709C10.4636 28.0054 9.75186 26.2896 9.75 24.5V11C9.75186 9.21036 10.4636 7.49455 11.7291 6.22908C12.9946 4.96362 14.7104 4.25186 16.5 4.25H21C22.7896 4.25186 24.5054 4.96362 25.7709 6.22908C27.0364 7.49455 27.7481 9.21036 27.75 11V24.5ZM19.875 8.75V15.5C19.875 15.7984 19.7565 16.0845 19.5455 16.2955C19.3345 16.5065 19.0484 16.625 18.75 16.625C18.4516 16.625 18.1655 16.5065 17.9545 16.2955C17.7435 16.0845 17.625 15.7984 17.625 15.5V8.75C17.625 8.45163 17.7435 8.16548 17.9545 7.9545C18.1655 7.74353 18.4516 7.625 18.75 7.625C19.0484 7.625 19.3345 7.74353 19.5455 7.9545C19.7565 8.16548 19.875 8.45163 19.875 8.75Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.63ca3a92a2880b8ca86c3b83c6f2b553.svg";
export { ForwardRef as ReactComponent };